import { Coordinate, HexColor } from '@nx-smartmonkey/shared/domain';

import { GeoFence } from '../../domain/geoFence/GeoFence';
import { GeoFenceDTO } from '../../domain/geoFence/GeoFenceDTO';

export class GeoFenceMapper {
  static toDomain(props: GeoFenceDTO): GeoFence {
    const { id, created_at, created_by, project_id, color, enabled, label, coordinates } = props;

    const colorDomain = HexColor.create(color);

    const multiCoordinates = coordinates.map((coordinate) =>
      coordinate.map((coordinate) => Coordinate.create({ lat: coordinate[0], lng: coordinate[1] }))
    );
    // const multiCoordinatesResult = Result.combine(multiCoordinates.flat());
    // const polygonsValueObject = multiCoordinates.map((coordinates) => Polygon.create(coordinates.map((coord) => coord.getValue())));

    return GeoFence.create(
      {
        created_at: created_at,
        created_by: created_by,
        project_id: project_id,
        enabled: enabled,
        color: colorDomain,
        coordinates: multiCoordinates,
        label: label,
      },
      id
    );
  }

  static toDTO(geoFence: GeoFence): GeoFenceDTO {
    return {
      id: geoFence.id,
      project_id: geoFence.project_id,
      enabled: geoFence.enabled,
      color: geoFence.color.value,
      coordinates: geoFence.coordinatesToArray(),
      label: geoFence.label,
      created_at: geoFence.created_at,
      created_by: geoFence.created_by,
    };
  }

  static cloneDomain(geoFence: GeoFence): GeoFence {
    return GeoFenceMapper.toDomain(GeoFenceMapper.toDTO(geoFence));
  }
}
